import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function Clients() {
  const { t } = useLang();
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/users").then(({ data }) => setUsers(data.filter(u => u.role === "client"))).catch(() => setUsers([]));
  }, []);
  return (
    <DashboardLayout title={t("clients.title")} subtitle={t("clients.subtitle")}>
      <div className="rounded-xl border border-zinc-800 overflow-hidden" data-testid="clients-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-zinc-500 border-b border-zinc-800 bg-zinc-900/40">
              <th className="p-3">{t("common.name")}</th>
              <th className="p-3">{t("common.email")}</th>
              <th className="p-3">{t("common.status")}</th>
              <th className="p-3">Since</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-b border-zinc-800 hover:bg-zinc-900/40">
                <td className="p-3 text-zinc-100">{u.name}</td>
                <td className="p-3 text-zinc-400">{u.email}</td>
                <td className="p-3">
                  <span className="inline-flex items-center gap-2 text-xs">
                    <span className={`w-2 h-2 rounded-full ${u.active ? "bg-emerald-500 glow-green" : "bg-zinc-500"}`} />
                    {u.active ? t("common.active") : t("common.inactive")}
                  </span>
                </td>
                <td className="p-3 text-zinc-500 text-xs">{u.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
            {users.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-zinc-500">{t("common.no_data")}</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
